
import { Component, Vue } from "vue-property-decorator";

@Component
export default class Navbar extends Vue {
  isMenuOpen = false;
  isNavCondensed = true;
  resizeFrame: number | null = null;

  mounted(): void {
    window.addEventListener("resize", this.handleResize);
    this.$nextTick(() => this.updateNavLayout());
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.handleResize);

    if (this.resizeFrame !== null) {
      window.cancelAnimationFrame(this.resizeFrame);
    }

    this.unlockPageScroll();
  }

  handleMenuShow(): void {
    if (window.innerWidth < 768) {
      this.isMenuOpen = true;
      document.documentElement.classList.add("navbar-menu-open");
      document.body.classList.add("navbar-menu-open");
    }
  }

  handleMenuHide(): void {
    this.isMenuOpen = false;
    this.unlockPageScroll();
  }

  handleMenuLinkClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (window.innerWidth < 768 && target.closest("a")) {
      this.closeMenu();
    }
  }

  handleResize(): void {
    if (window.innerWidth >= 768 && this.isMenuOpen) {
      this.closeMenu();
    }

    if (this.resizeFrame !== null) {
      window.cancelAnimationFrame(this.resizeFrame);
    }

    this.resizeFrame = window.requestAnimationFrame(() => {
      this.resizeFrame = null;
      this.updateNavLayout();
    });
  }

  updateNavLayout(): void {
    if (window.innerWidth < 768) {
      this.isNavCondensed = true;
      return;
    }

    this.$nextTick(() => {
      const mainNav = this.getRefElement("mainNav");
      const navbarBrand = this.getRefElement("navbarBrand");
      const primaryNav = this.getRefElement("primaryNav");
      const secondaryNav = this.getRefElement("secondaryNavExpanded");

      if (!mainNav || !navbarBrand || !primaryNav || !secondaryNav) {
        return;
      }

      const brandStyle = window.getComputedStyle(navbarBrand);
      const brandOuterWidth = navbarBrand.getBoundingClientRect().width
        + parseFloat(brandStyle.marginLeft || "0")
        + parseFloat(brandStyle.marginRight || "0");
      const requiredWidth = brandOuterWidth
        + primaryNav.scrollWidth
        + secondaryNav.scrollWidth;

      this.isNavCondensed = Math.ceil(requiredWidth) > mainNav.clientWidth;
    });
  }

  getRefElement(refName: string): HTMLElement | null {
    const ref = this.$refs[refName] as Vue | HTMLElement | undefined;

    if (!ref) {
      return null;
    }

    return ref instanceof HTMLElement ? ref : ref.$el as HTMLElement;
  }

  closeMenu(): void {
    if (this.isMenuOpen) {
      this.$root.$emit("bv::toggle::collapse", "nav_collapse");
    }
  }

  unlockPageScroll(): void {
    document.documentElement.classList.remove("navbar-menu-open");
    document.body.classList.remove("navbar-menu-open");
  }
}
